"use strict";

import React, { Component, PropTypes } from 'react';
import { Row, Col,Button } from 'react-bootstrap';
import { Joi, Validation } from 'react-validation-decorator';
import AccountActions from '../../../actions/AccountActions';
import AlertActions from '../../../actions/AlertActions';
import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css'

class PersonalDetailsForm extends Component{
  constructor(props) {
    super(props);
    this.state = {
      agreeToPolicy : false,
      isEmailAlreadyExists : false,
      emailErrorMsg : '',
      canSubmit : false,
      showLoadingBar : false
    };

    this._handleInputChange = this._handleInputChange.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
  };
  static contextTypes = {
    router: React.PropTypes.object
  };
  validationSchema = Joi.object().keys({
    firstName: Joi.string().required().label('First Name'),
    lastName: Joi.string().required().label('Last Name'),
    email: Joi.string().email().lowercase().required().label('Email'),
    agreeToPolicy: Joi.boolean().required().invalid(false),
    password: Joi.string().min(8).max(30).required().label('Password'),
    confirmPassword: Joi.string().valid(Joi.ref('password')).options({
      language: {
        any: {
          allowOnly: 'don\'t match'
        }
      }
    }).required().label('Confirm Password')
  });

  render() {
    const {isEmailAlreadyExists, emailErrorMsg, canSubmit, showLoadingBar} = this.state;
    console.log("this.state.validation.errors.length=========",this.state.validation.errors);
    console.log("isEmailAlreadyExists=========",isEmailAlreadyExists);
    return (
      <div className="info-box-large round-corner clearfix h-100p">
        {showLoadingBar &&
          <Loading showSpinner={true} show={showLoadingBar} color="red" />
        }
        <div className="titleBox">
        <a href="javascript:void(0)" className="pull-right text-muted h4 m0 py5" onClick={()=>{
              this.props._handleModalHandler('signUpModal',false)
            }}>X</a>
          <h4 className="title m0 py5">Sign up</h4>
        </div>
        <div className="col-sm-12 mt20 mb20">
          <form name="signUpFrm" noValidate>
            <Row>
            <Col md={6}>
            <div className={this.getValidationClassName('firstName')}>
              <label>First Name</label>
              <input type='text' className='form-control'
              value={this.state.firstName}
              placeholder="Enter First Name..."
              onChange={this._handleInputChange.bind(this, 'firstName')}/>
              {this.renderValidationMessages('firstName')}
            </div>
            </Col>
            <Col md={6}>
            <div className={this.getValidationClassName('lastName')}>
              <label>Last Name</label>
              <input type='text' className='form-control'
              value={this.state.lastName}
              placeholder="Enter Last Name..."
              onChange={this._handleInputChange.bind(this, 'lastName')}/>
              {this.renderValidationMessages('lastName')}
            </div>
            </Col>
            <Col md={12}>
            <div className={this.getValidationClassName('email')}>
              <label>Email</label>
              <input type='email' className='form-control'
              value={this.state.email}
              placeholder="Enter Email..."
              onBlur = {this._handleCheckEmailAvailability}
              onChange={this._handleInputChange.bind(this, 'email')}/>
              {this.renderValidationMessages('email')}
              {isEmailAlreadyExists  &&
                <div style={{display : 'block', marginBottom : '10px', marginTop : '5px', color : '#a94442'}}>
                    <div>Email already exists. Please use log in or forgot password.</div>
                </div>
              }
            </div>
            </Col>
            <Col md={6}>
            <div className={this.getValidationClassName('password')}>
              <label>Password</label>
              <input type='password' className='form-control'
              value={this.state.password}
              placeholder="Enter Password..."
              onChange={this._handleInputChange.bind(this, 'password')}/>
              {this.renderValidationMessages('password')}
            </div>
            </Col>
            <Col md={6}>
            <div className={this.getValidationClassName('confirmPassword')}>
              <label>Confirm Password</label>
              <input type='password' className='form-control'
              value={this.state.confirmPassword}
              placeholder="Enter Confirm Password..."
              onChange={this._handleInputChange.bind(this, 'confirmPassword')}/>
              {this.renderValidationMessages('confirmPassword')}
            </div>
            </Col>
            <Col>
            <div>
              <label style={{fontWeight:'normal'}}>
                <input style={{marginLeft:'15px',marginRight:'5px'}} type="checkbox" value={this.state.agreeToPolicy} onChange={this._handleInputChange.bind(this, 'agreeToPolicy')}/>
                I agree to the <a href="https://mentorstudents.org/terms-and-conditions" target="_blank">Terms of Use</a> and <a href="https://mentorstudents.org/privacy-policy" target="_blank">Privacy Policy</a>
              </label>
            </div>
            </Col>
            <div className="col-xs-12 mt10">
            <Button type="submit" bsStyle="success" disabled={!!(this.state.validation.errors.length) || !canSubmit} onClick={this._handleSubmit} >Sign Up</Button>
            <a href="javascript:void(0);" className="ml10" onClick={this.props.toggleModal} >Log In</a>
            </div>
            </Row>
          </form>
        </div>
      </div>
    );
  };

  _handleInputChange(formInput, event) {
    let value = event.target.value;
    let newState = {};
    if (formInput === 'agreeToPolicy') {
      value = !this.state['agreeToPolicy'];
    }
    newState[formInput] = value;
    if(formInput === 'email') newState['canSubmit'] = false;
    this.setState(newState,()=>{
      this.validate(formInput);
    })
    // this.setState(state => {
    //   state[formInput] = value;
    // }, () => {
    //   this.validate(formInput);
    // });
  };
  _handleSubmit(e) {
    e.preventDefault();
    let user = this.state.validation.value;
    const {firstName, lastName, email, password} = user;
    const payload = {firstName, lastName, email, password};
    delete user.agreeToPolicy;
    delete user.confirmPassword;
    // console.log("personal file00-0===========",user);
    this.setState({showLoadingBar : true});
    AccountActions.register(payload,  (error)=> {
      this.setState({showLoadingBar : false});
      if (error) {return AlertActions.error({ message: error.message });}
      else {
        this.props._handleModalHandler('signUpModal',false);
        this.context.router.push('/user/conferences');
      }
    });
  };
  _handleCheckEmailAvailability = ()=>{
    // console.log("ready to call check email available",this.state.email);
    console.log("check email availbl=========",this.state.validation.errors, this.state.email);
    const emailErrorObj = this.state.validation.errors.find(obj=> obj.path == 'email');
    console.log("emailErrorObj========",emailErrorObj);
    if(this.state.email && this.state.email.length > 0 && !emailErrorObj){
      AccountActions.checkEmailAvailable(this.state.email,(error)=>{
        // console.log("Error-----------",error);
        if (error) {this.setState({isEmailAlreadyExists : true, emailErrorMsg : error.message,canSubmit : false})}
        else{
          this.setState({isEmailAlreadyExists : false, emailErrorMsg : null, canSubmit : true});
        }
      })  
    }
  }
  getModel() {
    return this.state.validation.value;
  };
}

export default Validation(PersonalDetailsForm);
